import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../shared/entity_datas/EntityDatas'
import {UIMSceneEnum} from '../../../../shared/enums/UIMSceneEnums'
import {MobileWebviewCommunicationActions} from '@colonist/mobile'
import {notificationController, socket, uiGameManager} from '../../../shared/scripts/EntryShared'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {UIMMobileWebviewCommunication} from '../ui_mobile_communication/UIMMobileWebviewCommunication'
import {UIMManager} from './UIMManager'
import {UIOnlineFriendController} from '../../../shared/scripts/ui_friends/UIOnlineFriendController'
import {UIMDeviceHandler} from './UIMDeviceHandler'

export class UIMSceneController {
    private readonly uiManager: UIMManager
    private _scene: UIMSceneEnum

    constructor(uiManager: UIMManager) {
        this.uiManager = uiManager
    }

    get scene(): UIMSceneEnum {
        return this._scene
    }

    loadScene(scene: UIMSceneEnum) {
        if(this._scene == scene) return

        if(scene == UIMSceneEnum.Game) return void this.loadGame()
        const isPlayerInCreateRoomFlow = this.uiManager.createRoomController.isUserOnCreateRoomFlow()
        if(isPlayerInCreateRoomFlow) return this.uiManager.createRoomController.onExitRoom(() => this.goToScene(scene), true)

        this.goToScene(scene)
    }

    private goToScene(scene: UIMSceneEnum) {
        const shouldMakeProfileFourthSection = UIUtilsEjsVariables.shouldHideStoreOnMobile && scene == UIMSceneEnum.Profile
        const updatedScene = shouldMakeProfileFourthSection ? scene - 1 : scene

        this.uiManager.mainpageController.bodyController.swipeNavigation.go(updatedScene)
    }

    onSceneChange(scene: UIMSceneEnum) {
        if(scene == UIMSceneEnum.Lobby) this.uiManager.mainpageController.bodyController.lobbyController.show()
        this._scene = scene
    }

    async loadGame() {
        this.uiManager.createRoomController.disableChatInput()
        const didPauseForKeyboard = await UIMDeviceHandler.pauseForKeyboardToClose()

        this.keepConnectionAlive()
        UIOnlineFriendController.userEnteredGame()
        notificationController.removeDisconnectBanners()
        this.uiManager.createRoomController.leaveRoom()
        this.uiManager.adController.hideAllAds()
        this.uiManager.mainpageController.bodyController.lobbyController.hide()
        this.uiManager.mainpageController.bodyController.hide()
        this.uiManager.mainpageController.headerController.hide()
        this.uiManager.mainpageController.navigationController.hide()
        this.uiManager.singletonPageController.closeAllPages()
        this.uiManager.singletonPageController.removeLinkListener()

        uiGameManager.canvasController.buildGame()
        if(didPauseForKeyboard) uiGameManager.canvasController.responsiveController.resizeScreen()

        this._scene = UIMSceneEnum.Game
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.GameStarted)

        const abTestEventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.MobileGameStarted,
            category: AnalyticEventCategory.MobileAnalytics,
            floatValue: Number(socket.gameListener.databaseGameId),
        }
        void CA.sendAnalyticEventsWithMobileDimensions(abTestEventData)

        if(UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) {
            window.addEventListener('pagehide', () => UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowSplashScreen, true))
            return
        }

        const sendRotation = setInterval(() => {
            const canvas = document.getElementsByTagName('canvas')
            if(canvas.length == 0) return
            clearInterval(sendRotation)
            UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.OrientationLandscape)
        }, 500)
    }

    // eslint-disable-next-line class-methods-use-this
    private keepConnectionAlive() {
        setInterval(() => {
            socket?.controller.sender.sendNoop()
        }, 10000)
    }
}
